import React from 'react';
import { Label, Input, FormFeedback } from 'reactstrap';
import ParadigmaAsyncSeeker from "../../../components/ParadigmaAsyncSeeker/ParadigmaAsyncSeeker.js"
import api from "../../../api";
import { validationInputProps } from "../../../utils/inputValidation";

const SubgroupField = ({ label, name, disabled = false, autoFocus = false, inputProps = {} }) => (
    <div className="ui-field">
        <Label>{label}</Label>
        <Input disabled={disabled} type="text" name={name} autoFocus={autoFocus} data-auto-focus={autoFocus ? "true" : null} {...inputProps}></Input>
        <FormFeedback className="col-12"></FormFeedback>
    </div>
);

const SubgroupFormFields = ({
    disabled = false,
    padreId,
    grupoFieldName = "padre_id",
    onGrupoChange,
    autoFocusFirstField = false,
}) => (
    <div className="ui-section-stack">
        <section className="ui-section-block">
            <p className="ui-section-label">Datos del subgrupo</p>
            <div className="ui-row-2">
                <SubgroupField disabled={disabled} autoFocus={autoFocusFirstField} label={"Nombre"} name={"nombre"} />
                <SubgroupField disabled={disabled} label={"Abreviatura"} name={"abreviatura"} />
            </div>
            <div className="ui-row-2">
                <SubgroupField disabled={disabled} label={"Email"} name={"mail"} />
                <SubgroupField disabled={disabled} label={"Teléfono"} name={"telefono"} inputProps={validationInputProps.telefono} />
            </div>
        </section>

        <section className="ui-section-block">
            <p className="ui-section-label">Pertenencia</p>
            <div className="ui-row-1">
                <div className="ui-field">
                    <Label>Grupo</Label>
                    <ParadigmaAsyncSeeker
                        disabled={disabled}
                        fieldName={grupoFieldName}
                        url={api.usuarios.grupos.select}
                        onChange={onGrupoChange}
                        value={padreId} />
                    <FormFeedback className="col-12"></FormFeedback>
                </div>
            </div>
        </section>
    </div>
);

export default SubgroupFormFields;



// WEBPACK FOOTER //
// ./src/views/Usuarios/Subgrupos/SubgroupFormFields.js